module.exports = __webpack_public_path__ + "img/web3icon9.ace7a47b.png";